import api, { unwrapList } from './api';
const vehicleService = {
  getAll:    (p)  => api.get('/vehicles/', { params: p }).then(r => unwrapList(r.data)),
  getDriverVehicles: () => api.get('/drivers/me/vehicles/').then(r => unwrapList(r.data)),
  getDriverActiveVehicle: () => api.get('/drivers/me/active-vehicle/').then(r => r.data),
  setDriverActiveVehicle: (vehicleId) =>
    api.post('/drivers/me/active-vehicle/', { vehicle_id: vehicleId }).then(r => r.data),
  getById:   (id) => api.get(`/vehicles/${id}/`).then(r => r.data),
  create:    (d)  => api.post('/vehicles/', d).then(r => r.data),
  update:    (id, d) => api.patch(`/vehicles/${id}/`, d).then(r => r.data),
  delete:    (id) => api.delete(`/vehicles/${id}/`),
  getStats:  (id) => api.get(`/vehicles/${id}/stats/`).then(r => r.data),
};
export default vehicleService;